// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__WkVWX","content":"RecentSearches_content__EnRUb"};